import React from "react";
import {
  IonItem,
  IonAvatar,
  IonImg,
  IonLabel,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonContent,
  IonChip,
  IonButton,
} from "@ionic/react";
import VisibilitySensor from "react-visibility-sensor";

import BookmarkOutlineIcon from "../../assets/icons/fb/bookmark-outline.png";
import BookmarkFillIcon from "../../assets/icons/fb/bookmark-fill.png";

import "./SimilarProducts.css";
import SeeAllSection from "./SeeAllSection";
import { shuffle } from "../../pages/Feed";

export default function SimilarProducts({
  title = "",
  products = [],
  onProductClick = () => {},
  onVisibilityChange = () => () => {},
  containment,
}) {
  const [grouped, setGrouped] = React.useState([]);
  React.useEffect(() => {
    const products2 = [
      // ...shuffle(products).map((p, order) => ({ ...p, order })),
      ...products,
    ];
    const groupedProducts = [];
    while (products2.length) {
      groupedProducts.push(products2.splice(0, 2));
    }
    setGrouped(groupedProducts);
  }, [products]);

  console.log({ grouped });
  return (
    <SeeAllSection title={title}>
      {grouped.map((group) => (
        <IonRow className="p-0 m-0 row-no-wrap">
          {group.map((product) => (
            <VisibilitySensor
              partialVisibility
              offset={{ top: 40, bottom: 40 }}
              containment={containment}
              onChange={onVisibilityChange(product)}
            >
              <ProductCard {...product} onClick={onProductClick(product)} />
            </VisibilitySensor>
          ))}
        </IonRow>
      ))}
    </SeeAllSection>
  );
}

export function ProductCard({
  src = "",
  name = "",
  price = "",
  discount = "",
  isBookmarked = false,
  brand = "",
  onClick = () => {},
}) {
  const [classes, setClasses] = React.useState("");
  const hasDiscount = React.useMemo(() => Boolean(discount), [discount]);

  const onAnimationStart = React.useCallback(() => {
    setTimeout(() => setClasses("fb-product-grow-animation"), 100);
    setTimeout(() => setClasses(""), 1500);
  }, []);

  return (
    <IonCol
      className={classes}
      onClick={() => {
        onClick();
        onAnimationStart();
      }}
    >
      <IonRow className="p-0 fb-product-card-img-wrapper">
        <IonImg className="fb-product-card-img" src={src} />
        {hasDiscount && <p className="fb-product-sale-badge">Sale</p>}
      </IonRow>

      <IonRow style={{ marginBottom: "8px" }}>
        <IonCol
          className="fb-product-info-wrapper"
          style={{ padding: "0 4px" }}
        >
          <IonRow className="ion-justify-content-between">
            <p className="fb-product-card-name">{name}</p>
            {isBookmarked ? (
              <IonImg
                className="fb-product-bookmark-icon"
                src={BookmarkFillIcon}
              />
            ) : (
              <IonImg
                className="fb-product-bookmark-icon"
                src={BookmarkOutlineIcon}
              />
            )}
          </IonRow>

          <IonRow>
            {hasDiscount && (
              <p className="fb-product-card-discount">{discount}</p>
            )}
            <p
              className={`fb-product-card-price ${
                hasDiscount ? "line-through" : ""
              }`}
            >
              {price}
            </p>
          </IonRow>
          {brand && <p className="fb-product-card-price">{brand}</p>}
        </IonCol>
      </IonRow>
    </IonCol>
  );
}
